import { Image } from 'antd-mobile';
import parse from 'html-react-parser'; // 导入替代库
import React, { useCallback } from 'react';

const RichTextDisplay = ({ htmlContent }) => {

  // 自定义处理标签（如图片）
  const handleNode = useCallback((node) => {
    // 处理 img 标签
    if (node.name === 'img') {
      const src = node.attribs.src;
      const alt = node.attribs.alt || '';
      return (
        <Image
          src={src}
          alt={alt}
          style={{ maxWidth: '100%', margin: '8px 0' }}
          onClick={() => console.log('图片点击', src)}
        />
      );
    }
    return node; // 其他标签默认处理
  }, []);

  if (!htmlContent) {
    return <div></div>;
  }
  return (
    <div style={{ lineHeight: '1.5' }}>
      {/* 解析 HTML，支持自定义节点处理 */}
      {parse(htmlContent, { replace: handleNode })}
    </div>
  );
};

export default RichTextDisplay;